import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiRP.get("/api/rp-fill-rate", { params });
};

const rpFillRateService = {
  getAll
};

export default rpFillRateService;